import Toast from "react-bootstrap/Toast";

export const ProcedureScheduledToast = () => {
  return (
    <div className="position-fixed bottom-4 start-50 translate-middle-x z-3">
      <Toast>
        <Toast.Body className="bg-success text-white">
          ¡Listo! Agendaste {`{1}`} procedimiento
        </Toast.Body>
      </Toast>
    </div>
  );
};
